import { render, staticRenderFns } from "./LibLink.vue?vue&type=template&id=96568be2&scoped=true"
import script from "./LibLink.vue?vue&type=script&lang=js"
export * from "./LibLink.vue?vue&type=script&lang=js"
import style0 from "./LibLink.vue?vue&type=style&index=0&id=96568be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96568be2",
  null
  
)

export default component.exports